import React, { useRef, useState } from 'react';
import { Play, Pause, Mic } from 'lucide-react';

export function VoiceNote({ url, mine }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [dur, setDur] = useState(0);
  const bars = React.useMemo(() => Array.from({ length: 34 }, (_, i) => 7 + ((i * 53) % 17)), []);
  const toggle = () => { const a = ref.current; if (!a) return; if (playing) a.pause(); else a.play().catch(() => {}); };
  const fmt = (s) => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
  return (
    <div className="flex items-center gap-3 px-3.5 py-3 min-w-[240px]" data-testid="voice-note">
      <audio ref={ref} src={url} preload="metadata"
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)}
        onEnded={() => { setPlaying(false); setProgress(0); }}
        onTimeUpdate={e => setProgress(e.target.duration ? e.target.currentTime / e.target.duration : 0)}
        onLoadedMetadata={e => setDur(e.target.duration || 0)} />
      <button data-testid="voice-note-play" onClick={toggle} className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 transition-transform hover:scale-105 ${mine ? 'bg-white text-[rgb(var(--a400))]' : 'bg-indigo-500 text-white'}`}>
        {playing ? <Pause size={16} /> : <Play size={16} className="ml-0.5" />}
      </button>
      <div className="flex items-center gap-[2px] flex-1 h-9">
        {bars.map((h, i) => (
          <span key={`bar-${i}-${h}`} className={`w-[3px] rounded-full transition-colors ${i / bars.length <= progress ? (mine ? 'bg-white' : 'bg-indigo-400') : (mine ? 'bg-white/35' : 'bg-slate-500/40')}`} style={{ height: `${h}px` }} />
        ))}
      </div>
      <span className={`text-[11px] shrink-0 tabular-nums ${mine ? 'text-indigo-100' : 'text-slate-400'}`}>{fmt(progress > 0 ? progress * dur : dur)}</span>
    </div>
  );
}

export function PickerVoice({ url }) {
  const ref = useRef(null);
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-1.5"
      onMouseEnter={() => ref.current?.play().catch(() => {})}
      onMouseLeave={() => { if (ref.current) { ref.current.pause(); ref.current.currentTime = 0; } }}>
      <audio ref={ref} src={url} preload="none" />
      <Mic size={20} className="text-indigo-400" />
      <span className="text-[8px] text-slate-400">Hover to play</span>
    </div>
  );
}
